$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#reviews_cart']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews_cart').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "button.quantity__button.quantity__button--minus.disabled", function (e) {
  e.preventDefault();
$(this).parents('.cart-drawer-item__right').find('cart-remove-button .button').trigger('click');
});
$(document).on("mousemove touchstart", "body", function(e) { 
if( $('.slider_cart_drawer:not(.slick-initialized)').length ) {
    $('.slider_cart_drawer:not(.slick-initialized)').slick({
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
    prevArrow: $('.prev_cart_drawer'),
    nextArrow: $('.next_cart_drawer'),
    appendDots: $('.dots_cart_drawer'),
  cssEase:'linear',
  responsive: [
    {
      breakpoint: 915,
      settings: {
        slidesToShow:1, 
adaptiveHeight: true,
      }
    }
  ]
});
}
});


$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   //jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    //jQuery(this).removeClass('active');
//video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});



$(document).on("click", "div#CartDrawer-Overlay", function (e) {
e.preventDefault();
$('div#CartDrawer .drawer__close').trigger('click');
});
$(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
$('body').addClass('mac-os');
}
});
$(document).on("click", "body .cart-drawer__body .upsell__add-btn", function (e) {
    jQuery(this).addClass('loading_hk');
});

